import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import { colors, typography } from '../../../styles';

const styles = css`
  margin: 30px 0;
  @media (min-width: 992px) {
    margin: 90px 0 -75px 0;
  }
  .TimelineBanner {
    padding: 90px 0 60px 0;
    position: relative;
    background-color: ${colors.brand6};
    background-image: url('/images/pattern-01-dark.svg');
    background-size: 110% auto;
    background-position: center center;
    @media (min-width: 992px) {
      padding: 120px 0 0 0;
    }
  }
  .TimelineBanner_iconGraphic {
    width: 90px;
    height: 90px;
    background-color: ${colors.white};
    border-radius: 50%;
    border: 8px solid ${colors.brand2};
    position: absolute;
    z-index: 3;
    left: 50%;
    top: -45px;
    transform: translateX(-50%);
    background-size: auto 60px;
    background-position: center center;
    background-repeat: no-repeat;
    @media (min-width: 992px) {
      width: 140px;
      height: 140px;
      top: -70px;
      background-size: auto 80px;
    }
  }
  .TimelineBanner_inner {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 15px;
  }
  .TimelineBanner_heading {
    text-align: center;
    position: relative;
    z-index: 3;
    &::after {
      content: '';
      display: block;
      position: relative;
      width: 125px;
      height: 2px;
      background-color: ${colors.brand2};
      margin: 30px auto;
    }
  }
  .TimelineBanner_headline {
    font-size: 30px;
    line-height: 1.2;
    font-family: ${typography.Serif};
    font-weight: 600;
    display: block;
    text-align: center;
    @media (min-width: 992px) {
      font-size: 50px;
    }
  }
  .TimelineBanner_text {
    max-width: 1000px;
  }
  .TimelineBanner_text p {
    text-align: center;
    @media (min-width: 992px) {
    }
  }
  .TimelineBanner_scrollWrapper {
    width: 100%;
    overflow-x: scroll;
    height: 1000px;
    -webkit-overflow-scrolling: touch;
    clip-path: inset(0 0 50px 0); /* hide scroll bar */
    @media (min-width: 1600px) {
      height: 1150px;
    }
  }
  .TimelineBanner_timeline {
    margin: 430px 0;
    padding: 0 100px;
    width: fit-content;
    white-space: nowrap;
    overflow-y: visible;
    height: 57px;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    position: relative;
    @media (min-width: 1600px) {
      margin: 540px 0;
    }
  }
  .TimelineBanner_card {
    width: 300px;
    flex-shrink: 0;
    margin: 0 0 81px -110px;
    display: block;
    background-color: ${colors.white};
    text-align: center;
    position: relative;
    z-index: 2;
    box-shadow: 0 12px 20px 0 rgba(0,0,0,0.1);
    @media (min-width: 768px) {
      margin: 0 0 81px -120px;
    }
    @media (min-width: 1600px) {
      width: 400px;
      margin: 0 0 81px -150px;
    }
    &:first-child {
      margin-left: -50px;
      @media (min-width: 768px) {
        margin-left: 0;
      }
    }
    &::after {
      content: '';
      display: block;
      position: absolute;
      width: 8px;
      background-color: ${colors.white};
      height: 60px;
      margin: 0 0 0 -4px;
      left: 50%;
      z-index: 1;
      top: auto;
    }
    &::before {
      content: '';
      display: block;
      position: absolute;
      width: 45px;
      height: 45px;
      border-radius: 50%;
      border: 8px solid ${colors.white};
      background-color: ${colors.brand3};
      margin: 0 0 0 -23.5px;
      left: 50%;
      bottom: -75px;
      z-index: 2;
      @media (min-width: 1600px) {
        width: 60px;
        height: 60px;
        margin: 0 0 0 -30px;
        bottom: -81px;
      }
    }
    &:nth-child(even) {
      align-self: flex-start;
      margin: 81px 0 0 -120px;
      @media (min-width: 1600px) {
        margin: 81px 0 0 -150px;
      }
      &::after {
        top: -60px;
        @media (min-width: 1600px) {
        }
      }
      &::before {
        bottom: auto;
        top: -75px;
        @media (min-width: 1600px) {
          top: -81px;
        }
      }
    }
  }
  .TimelineBanner_cardImage {
    width: 100%;
    height: auto;
  }
  .TimelineBanner_cardYear {
    background-color: ${colors.brand1};
    color: ${colors.white};
    font-size: 24px;
    line-height: 1;
    font-weight: 700;
    padding: 8px 18px;
    position: relative;
    z-index: 2;
    display: block;
    position: absolute;
    top: 140px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 5px;
    box-shadow: 0 9px 12px 0 rgba(0,0,0,0.1);
    @media (min-width: 1600px) {
      padding: 10px 25px;
      font-size: 30px;
      top: 187px;
    }
  }
  .TimelineBanner_cardDescription p {
    font-size: 16px;
    line-height: 1.4;
    margin: 0;
    padding: 30px 20px 20px 20px;
    text-align: left;
    white-space: normal;
    @media (min-width: 1600px) {
      padding: 40px 30px 30px 30px;
      font-size: 17px;
    }
  }
  .TimelineBanner_timlineLine {
    width: calc(100% - 100px);
    height: 23px;
    border: 6px solid ${colors.white};
    background-color: ${colors.brand1};
    position: absolute;
    z-index: 1;
    overflow: visible;
    top: 17px;
    left: 50px;
    &::before, &::after {
      content: '';
      display: block;
      position: absolute;
      left: -10px;
      top: -21px;
      width: 57px;
      height: 53px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
      background-image: url('/images/icon-timeline-endcap.svg');
    }
    &::after {
      left: auto;
      right: -10px;
      transform: scaleX(-1);
    }
  }
`;

function TimelineBanner({ content }) {
  return (
    <div className={styles}>
      <div className="TimelineBanner">
        {
          get(content, '[0].icon.contentUrl') &&
          <div className="TimelineBanner_iconGraphic" style={{ backgroundImage: `url(${get(content[0], 'icon.contentUrl')}` }} />
        }
        <div className="container">
          <div className="TimelineBanner_inner">
            <h2 className="TimelineBanner_heading">
              {
                get(content, '[0].headline') &&
                <span className="TimelineBanner_headline">{get(content, '[0].headline')}</span>
              }
            </h2>
            <div className="TimelineBanner_text" dangerouslySetInnerHTML={SanitizeHtml(get(content[0], 'text'))} />
          </div>
        </div>
        <div className="TimelineBanner_scrollWrapper">
          <div className="TimelineBanner_timeline">
            {
              get(content, '[0]milestones' || []).map(milestone => {
                return (
                  <div className="TimelineBanner_card" key={milestone._id}>
                    <Image
                      className="TimelineBanner_cardImage"
                      src={get(milestone, 'image.contentUrl')}
                      width={450}
                      height={240}
                      exact
                      applySize
                      alt={get(milestone, 'image.name')}
                    />
                    <div className="TimelineBanner_cardYear">{get(milestone, 'year')}</div>
                    <div className="TimelineBanner_cardDescription" dangerouslySetInnerHTML={SanitizeHtml(get(milestone, 'description'))} />
                  </div>
                );
              })
            }
            <div className="TimelineBanner_timlineLine" />
          </div>
        </div>
      </div>
    </div>
  );
}

TimelineBanner.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default TimelineBanner;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/Timeline.section.js